import * as actionTypes from '../actions/actionTypes'

export default function loadingReducer(state = false, action)
{
   switch (action.type)
   {
      case actionTypes.SET_LOADING:
         return action.payload
      default:
         return state
   }
}
